import React, { Fragment } from 'react';
import { GoldButton } from './GoldButton';
import { useCountdown } from '../hooks/useCountdown';
import { motion } from 'framer-motion';
interface DateCountdownCardProps {
  onRegisterClick: () => void;
}
export function DateCountdownCard({
  onRegisterClick
}: DateCountdownCardProps) {
  // Set target date to May 20, 2026 6:00 PM EST
  const targetDate = new Date('2026-05-20T18:00:00-05:00');
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown(targetDate);
  const timeBlocks = [{
    label: 'Days',
    value: days
  }, {
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div className="relative z-20 container mx-auto px-4 -mt-24 md:-mt-32 mb-16 md:mb-24" data-id="element-37">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto bg-brand-navy border border-brand-gold/40 rounded-2xl p-6 md:p-10 text-center shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-38">
        <p className="font-display text-white uppercase tracking-widest text-xs md:text-sm mb-3" data-id="element-39">
          Save the Date: 90 Minute Commercial Real Estate Workshop
        </p>

        <h2 className="font-display text-white text-3xl md:text-5xl font-bold mb-8" data-id="element-40">
          Wednesday, May 20th at 6PM EST
        </h2>

        <div className="mb-10 flex justify-center w-full" data-id="element-41">
          <GoldButton onClick={onRegisterClick} mainText="Secure Ticket Now" subText="(LIMITED SEATS AVAILABLE)" className="w-full md:w-auto md:min-w-[300px]" data-id="element-42" />
        </div>

        <div className="flex justify-center items-center gap-2 md:gap-6" data-id="element-43">
          {timeBlocks.map((block, index) => <Fragment key={block.label} data-id="element-44">
              <div className="flex flex-col items-center w-16 md:w-24" data-id="element-45">
                <div className="font-display font-bold text-3xl md:text-5xl text-white mb-1" data-id="element-46">
                  {block.value.toString().padStart(2, '0')}
                </div>
                <div className="font-display text-[10px] md:text-xs text-brand-gold uppercase tracking-widest" data-id="element-47">
                  {block.label}
                </div>
              </div>
              {index < timeBlocks.length - 1 && <div className="w-[1px] h-10 md:h-12 bg-brand-gold/30" data-id="element-48"></div>}
            </Fragment>)}
        </div>
      </motion.div>
    </div>;
}